import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-xl border bg-card p-5', className)} {...props} />
}

/** The uppercase micro-label used across tiles and cards. */
export function KLabel({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'font-display text-[10px] font-semibold uppercase tracking-[0.12em] text-faint',
        className,
      )}
      {...props}
    />
  )
}
